@if (!config?.cellRenderer) {
  @if (value !== undefined) {
    <div [tooltip]="value">
    {{ value }}
      </div>
  }
  @else {
    <span class="text-slate-300">-</span>
  }
}
